import { Outlet } from "react-router-dom";
import { DasboardContext } from "../../../context";
import Header from "./header";
import SideBar from "./sidebar";

const LayoutComponent=()=>{
    return <section style={{position:"relative",paddingLeft:"228px"}}>
        <DasboardContext.Provider value={{}}>
            <SideBar/>
            <Header/>
            <div className="layout__container">
                        <Outlet />
                    </div>
        </DasboardContext.Provider>
    </section>
};
export default LayoutComponent